import { BaseService } from "@common/http-layer/service/base.service";
import { useLocation } from "@common/location-layer/composables/useLocation";

import type {
  SearchItem,
  SearchCountResponse,
} from "@courses/types-layer/types/search";

export class SearchService extends BaseService {
  constructor() {
    super({
      baseURL: "MEMBERSHIPS_SERVER_URL",
      basePath: "",
    });
  }

  private endpoint(path: string = ""): string {
    const { store: state } = useLocation();
    if (!state.locationId) throw new Error("Location ID is required");
    return `/locations/${state.locationId}/universal-search${path}`;
  }

  async searchCount(params: {
    searchKey: string;
  }): Promise<SearchCountResponse> {
    const { data } = await this.get<SearchCountResponse>(
      this.endpoint("/search-count"),
      {
        params,
      },
    );
    return data;
  }

  async searchItems(params: {
    searchKey: string;
    pageLimit?: number;
    pageNumber?: number;
  }): Promise<SearchItem[]> {
    const { data } = await this.get<SearchItem[]>(
      this.endpoint("/full-text-search-v2"),
      {
        params,
      },
    );
    return data;
  }

  async getProductTitles(params: {
    productIds: string[];
  }): Promise<Record<string, string>> {
    const { data } = await this.post<Record<string, string>>(
      this.endpoint("/product-title"),
      params,
    );
    return data;
  }
}
